;(globalThis as any).global = globalThis;